// extracted by mini-css-extract-plugin
export default {"content":"xS-z","lookName":"yS-z","shopTheLookContainer":"zS-z","productContainer":"AS-z","imageContainer":"BS-z","mainImage":"CS-z"};